// extracted by mini-css-extract-plugin
module.exports =  {"root":"Fi1m_XX7EaPDktIIFA7R"};